<ul nz-menu [nzTheme]="'dark'" [nzMode]="'horizontal'" style="line-height: 64px;">
  <li nz-menu-item>nav 1</li>
  <li nz-menu-item>nav 2</li>
  <li nz-menu-item>nav 3</li>
</ul>